import { render } from "./Home.vue?vue&type=template&id=702f3ccb"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script